import LoadingImage from "./LoadingImage";
import { LoadingPanel } from "./LoadingPanel";
import LoadingWhapper from "./LoadingWhapper";

export {
    LoadingImage,
    LoadingPanel,
    LoadingWhapper
}


// WEBPACK FOOTER //
// ./src/modules/comum/loading/components/index.js